import { boolean, date, index, pgTable, text, timestamp } from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { user } from "./auth";
import { studentGroups } from "./master";

/**
 * Students - ข้อมูลนักเรียน
 * เก็บข้อมูลนักเรียนทั้งหมดในระบบ พร้อม Member ID ที่ auto-generate
 */
export const students = pgTable(
  "students",
  {
    /** Primary key - ใช้ nanoid() สำหรับ generate ID */
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    /** Member ID ที่ auto-generate เป็น running number (ST000001, ST000002, ...) - unique และห้ามแก้ไข */
    memberId: text("member_id").notNull().unique(),
    /** ชื่อ-นามสกุล (ชื่อจริง) */
    name: text("name").notNull(),
    /** ชื่อเล่น — ไม่บังคับ */
    nickname: text("nickname"),
    /** เบอร์โทรศัพท์ (ไม่จำเป็นต้อง unique แต่แนะนำให้ unique) */
    phoneNumber: text("phone_number"),
    /** ยินยอมรับแจ้งเตือน WhatsApp */
    whatsappOptIn: boolean("whatsapp_opt_in").notNull().default(false),
    whatsappOptInAt: timestamp("whatsapp_opt_in_at", {
      mode: "string",
      withTimezone: false,
    }),
    /** อีเมล */
    email: text("email"),
    /** วันเดือนปีเกิด (YYYY-MM-DD) */
    dateOfBirth: date("date_of_birth", { mode: "string" }),
    /** เพศ: male (ชาย), female (หญิง), other (อื่นๆ) */
    gender: text("gender", {
      enum: ["male", "female", "other"],
    }),
    /** สถานะ: active (ใช้งาน) หรือ deactivated (ปิดการใช้งาน) */
    status: text("status", {
      enum: ["active", "deactivated"],
    })
      .notNull()
      .default("active"),
    /** หมายเหตุเพิ่มเติมเกี่ยวกับนักเรียน */
    notes: text("notes"),
    /** รูปภาพโปรไฟล์ - key ใน MinIO (uploads/students/xxx.jpg) */
    image: text("image"),
    /** เอกสารสมาชิกที่ลงนามแล้ว (scan/PDF) — S3 key */
    membershipSignedDocumentFileId: text("membership_signed_document_file_id"),
    /** วันที่อัปโหลดเอกสารสมาชิกที่ลงนามแล้ว */
    membershipSignedDocumentUploadedAt: timestamp(
      "membership_signed_document_uploaded_at",
      { mode: "string", withTimezone: false },
    ),
    /** กลุ่มนักเรียน - reference ไปยัง student_groups table */
    groupId: text("group_id").references(() => studentGroups.id, {
      onDelete: "set null",
    }),
    /** ผู้สร้างข้อมูล - reference ไปยัง user table */
    createdBy: text("created_by").references(() => user.id, {
      onDelete: "set null",
    }),
    /** วันที่สร้างข้อมูล */
    createdAt: timestamp("created_at", { mode: "string", withTimezone: false })
      .notNull()
      .defaultNow(),
    /** วันที่อัปเดตล่าสุด */
    updatedAt: timestamp("updated_at", { mode: "string", withTimezone: false })
      .notNull()
      .defaultNow(),
  },
  (t) => [
    index("students_by_member_id").on(t.memberId),
    index("students_by_status").on(t.status),
    index("students_by_phone_number").on(t.phoneNumber),
    index("students_by_email").on(t.email),
    index("students_by_date_of_birth").on(t.dateOfBirth),
    index("students_by_gender").on(t.gender),
    index("students_by_name").on(t.name),
    index("students_by_nickname").on(t.nickname),
    index("students_by_group_id").on(t.groupId),
    index("students_by_created_by").on(t.createdBy),
  ],
);
